import {
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  Typography,
  DialogActions,
  Button,
} from "@mui/material";
import { Fragment, FunctionComponent, useEffect } from "react";
import { GroupedOptionListItem } from "../../utils/group";

import { gql } from "@shared/utils";
const REMOVE_PRODUCT_CONFIGURATION_LIST_ITEM = gql`
  mutation RemoveProductConfigurationListItem(
    $subCategoryIds: [String!]
    $productConfigurationId: String!
  ) {
    removeProductConfigurationListItem(
      input: { id: $productConfigurationId, subCategoryIds: $subCategoryIds }
    ) {
      _id
      OptionsList {
        SubCategory {
          name
          maxOptions
          _id
          Category {
            name
            _id
          }
          Options {
            name
            _id
            AllowList {
              subcategory
              options
            }
          }
        }
        options
      }
    }
  }
`;
import {useMutation} from '@apollo/client/react';
export const RemoveCategory: FunctionComponent<{
  open: boolean;
  productConfigurationId: string;
  removeCategoryId: string;
  groupedOptions: GroupedOptionListItem[];
  onClose?: () => any;
  onRemoved?: () => any;
}> = ({
  open,
  removeCategoryId,
  productConfigurationId,
  groupedOptions,
  onClose,
  onRemoved,
}) => {
  const theme = useTheme();
  const item = groupedOptions.find((g) => g.category?._id == removeCategoryId);

  const [removeProductConfigurationListItem] = useMutation(
    REMOVE_PRODUCT_CONFIGURATION_LIST_ITEM,
  );

  if (!item) {
    return <></>;
  }
  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          onClose && onClose();
        }}
      >
        <DialogTitle
          sx={{
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          }}
        >
          Remove {item.category.name}
        </DialogTitle>
        <DialogContent>
          <Typography variant="h6">Do you really want to remove</Typography>
          <ul>
            {item.items.map((c) => {
              const sub = c.SubCategory;
              if (!sub) return null;
              return (
                <Fragment key={sub._id}>
                  <li>
                    {item.category.name} - {sub.name}
                  </li>
                </Fragment>
              );
            })}
          </ul>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              onClose && onClose();
            }}
          >
            No
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              removeProductConfigurationListItem({
                variables: {
                  subCategoryIds: item.items
                    .map((i) => i.SubCategory?._id)
                    .filter((id): id is string => Boolean(id)),
                  productConfigurationId,
                },
              })
                .then(() => {
                  try { onRemoved?.(); } catch (e) { console.error("onRemoved callback error:", e); }
                  onClose?.();
                })
                .catch((err) => {
                  console.error("Error removing category:", err);
                  onClose?.();
                });
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
